<template>
    <b-autocomplete
        v-model="search"
        :placeholder="placeholder"
        open-on-focus
        :data="filteredData"
        :field="field"
        @select="itemSelected"
        clearable
        :loading="isLoading"
    >
        <template #header v-if="showAddNew">
            <a @click="$emit('addNew')">
                <span> Add new... </span>
            </a>
        </template>
        <template #empty>No results.</template>
    </b-autocomplete>
</template>

<script>
export default {
    props: {
        value: {
            default: "",
            type: String,
        },
        placeholder: {
            default: "",
            type: String,
        },
        field: {
            default: "",
            type: String,
        },
        dataList: {
            default: () => [],
            type: Array,
        },
        searchFields: {
            default: () => [],
            type: Array,
        },
        setId: {
            default: undefined,
        },
        showAddNew: {
            type: Boolean,
            default: false,
        },
        picker: {
            type: Boolean,
            default: false,
        },
        // listUri: {
        //     default: null,
        //     type: String,
        // },
    },
    data: function () {
        return {
            search: "",
            isLoading: false,
            myOwnList: [],
        };
    },
    methods: {
        itemSelected(option) {
            if (!option) {
                return;
            }
            this.$emit("selected", option);
            if (this.picker) {
                setTimeout(() => (this.search = ""), 50);
            }
        },
    },
    created() {
        if (this.setId) {
            const selectedItem = this.dataList.filter((item) => item.id == this.setId);
            this.search = selectedItem[0][this.field];
        }
        // if (this.listUri) {
        //     this.isLoading = true;
        //     this.$http
        //         .get(this.listUri)
        //         .then((res) => {
        //             this.myOwnList = res.data;
        //         })
        //         .finally(() => (this.isLoading = false));
        // }
    },
    computed: {
        filteredData() {
            const list = this.dataList; // ?? this.myOwnList;
            if (!this.search) {
                return list;
            }
            return list.filter((item) => {
                let found = false;
                this.searchFields.forEach((field) => {
                    if (item[field]) {
                        found = found || item[field].toLowerCase().includes(this.search.toLowerCase());
                    }
                });
                return found;
            });
        },
    },
    watch: {
        value(newVal) {
            this.search = newVal;
            // if (oldVal == "" && /^\d+$/.test(newVal)) {
            //     const item = this.dataList.find((val) => val.id == newVal);
            //     if (item) {
            //         this.$emit("selected", item);
            //         this.search = item[this.field];
            //     }
            // }
        },
        search(newVal) {
            this.$emit("input", newVal);
            if (!newVal) {
                this.$emit("selected", undefined);
            }
        },
    },
};
</script>

<style>
</style>